/**
 * Lazily-loaded application chrome (the Skote layout).
 *
 * The import is shared between React.lazy and the login screen (which calls
 * {@link loadAppShell} before navigating) so the layout chunk downloads in
 * parallel with the post-login page chunk instead of after it.
 */
let appShellPromise: Promise<any> | null = null;

export const loadAppShell = (): Promise<any> => {
    if (appShellPromise == null) {
        appShellPromise = import('../templates/skote/SkoteLayout');
    }
    return appShellPromise;
};
